/**
 * 多人拼单发起弹窗
 */
import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { IonModal, IonContent, IonFooter } from '@ionic/react'
import { decorationMobx, buyTogetherMobx } from '@mobxStore'
import TypeSwitcher from './components/TypeSwitcher'
import SelectStore from './components/SelectStore'
import SelectAddress from './components/SelectAddress'
import './index.scss'

interface IProps {
  from?: string;
  callback?: () => void;
  reject?: (err: any) => void;
  resolve?: () => void;
}

const BuyTogetherModal: React.FC<IProps> = (props) => {
  const { reject, resolve, from } = props
  const { homeDecorates } = decorationMobx
  const { eatType, addressInfo, storeInfoByType, btEntrie, isReadyToStart } = buyTogetherMobx
  const canEatTypes = { delivery: true, pickup: true }
  const eatTypes = (homeDecorates.entrySetting?.brandCode?.entries || []).filter((item) => canEatTypes[item.type])

  useEffect(() => {
    buyTogetherMobx.initStart(from)
    buyTogetherMobx.setOpen(true)
  }, [])

  const handleConfirm = () => {
    buyTogetherMobx.createRoom()
    // resolve()
  }

  const handleClose = (needInitOpen?: boolean) => {
    if (needInitOpen) {
      buyTogetherMobx.setOpen()
    }
    reject('close')
  }
  return eatType ? (
    <IonModal
      isOpen
      swipeToClose
      cssClass='multi-spell-start-modal'
      // onDidDismiss={handleClose}
    >
      <IonContent>
        <div className='multi-page-mask' onClick={() => handleClose(true)}></div>
        <div className='multi-spell-content'>
          <div className='multi-spell-start-header'>
            <span>{btEntrie.name || i18n.t('menu.buyTogetherMenu')}</span>
            <i className='iconfont icon-close' onClick={() => handleClose(true)}></i>
          </div>
          <TypeSwitcher
            types={buyTogetherMobx.btEatEntries}
            value={buyTogetherMobx.eatType}
            onChange={(value) => {
              buyTogetherMobx.setEatType(value)
            }}
          />
          {
            buyTogetherMobx.eatType === 'delivery' && (
              <SelectAddress
                store={storeInfoByType.store}
                info={addressInfo}
                eatType={eatType}
                onChange={(data) => {
                  buyTogetherMobx.setAddress(data)
                }}
              />
            )
          }
          <SelectStore
            store={storeInfoByType.store}
            eatType={eatType}
          />
        </div>
      </IonContent>
      <IonFooter>
        <div className='footer-container'>
          <button className='btn cancel' onClick={() => handleClose(false)}>
            <span>{i18n.t('common.cancel')}</span>
          </button>
          <button className='btn confirm' disabled={!isReadyToStart} onClick={() => handleConfirm()}>
            <span>{i18n.t('menu.startBuyTogetherMenu')}</span>
          </button>
        </div>
      </IonFooter>
    </IonModal>
  ) : (<></>)
}

export default observer(BuyTogetherModal)
